import { defineStore } from "pinia";
import { ref, Ref } from "vue";
import {
  IWorkSchedule,
  IWorkScheduleFilter,
  IOverrideDayOff,
} from "@/features/work-schedule/work-schedule.types";
import { workScheduleService } from "@/features/work-schedule/work-schedule.service";
import { useNotification } from "@/utils/notification";

const { pushNotification } = useNotification();

export const useWorkScheduleStore = defineStore("workSchedule", () => {
  const schedule = ref<IWorkSchedule | null>(null);
  const customFilter = ref<IWorkScheduleFilter>({
    period: "week",
    period_date: "",
    shift_id: "",
    team_id: "",
  });

  async function getWorkSchedule(
    loading: Ref<boolean>
  ): Promise<IWorkSchedule | null> {
    try {
      loading.value = true;
      const { data } = await workScheduleService.getWorkSchedule({
        ...customFilter.value,
      });
      schedule.value = data;
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      pushNotification(message, "error");
      return null;
    } finally {
      loading.value = false;
    }
  }

  async function overrideDayOff(
    loading: Ref<boolean>,
    userId: string,
    payload: IOverrideDayOff
  ) {
    try {
      loading.value = true;
      const { data } = await workScheduleService.overrideDayOff(
        userId,
        payload
      );
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      pushNotification(message, "error");
      return null;
    } finally {
      loading.value = false;
    }
  }

  async function deleteOverrideDayOff(
    loading: Ref<boolean>,
    userId: string,
    weekStart: string
  ) {
    try {
      loading.value = true;
      const { data } = await workScheduleService.deleteOverrideDayOff(
        userId,
        weekStart
      );
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      pushNotification(message, "error");
      return null;
    } finally {
      loading.value = false;
    }
  }

  return {
    schedule,
    getWorkSchedule,
    overrideDayOff,
    deleteOverrideDayOff,
    customFilter,
  };
});
